<template>
 <transition name="fade">
    <div class="news-detail-page">
    <div class="main-container" v-if="newsDetail">
      <h3 class="title" v-html="newsDetail && newsDetail.title"></h3>
      <p class="date">{{newsDetail.date_published | date('MMM DD, YYYY')}}</p>
      <div class="content" v-html="newsDetail && newsDetail.content_html"></div>
    </div>
    <GPFooter />
  </div>
  </transition>
</template>
<style lang="scss">
  .news-detail-page {
    width: 100%;
    padding-top: 4.3vw;
    margin: 5vw auto 0;
    word-break: break-word;
    .main-container {
      min-height: calc(100vh - 16.5vw);
    }
    .title {
      text-align: center;
      font-size: 3vw;
      margin: 0;
    }
    .date {
      text-align: center;
      font-size: 1vw;
    }
    .content {
      width: 80%;
      margin: 3vw auto;
      font-size: 1.2vw;
      line-height: 2vw;
    }
    figure {
      margin: 0 auto;
    }
    video,
    img {
      border-radius:1%;
      width: 70%;
      height: auto;
      margin: 0 auto;
      display: block;
    }
  }
  @media (max-width: 1024px) {
    .news-detail-page {
      padding-top: 12vw;
      .title {
        font-size: 5vw;
        line-height: 8vw;
      }
      .main-container {
        min-height: calc(100vh - 30.9vw);
      }
      .date {
        font-size: 3vw;
      }
      .content {
        font-size: 4vw;
        line-height: 8vw;
      }
      video,
      img {
        width: 100%;
      }
    }
  }
</style>

<script>
import DataService from '../services/DataService'
export default {
  name: 'NewsDetailPage',
  props: {
  },
  data () {
    return {
      newsDetail: null
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
    DataService.getNewsContent(this.$route.params.id).then((response) => {
      this.newsDetail = response
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/NewsDetailPage.vue